/**
 * Hotel Thank You Selectors
 */
import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/store';

// ============================================
// Base Selector
// ============================================

const selectHotelThankYouState = (state: RootState) => state.hotelThankYou;

// ============================================
// Selectors
// ============================================

export const selectIsHotelThankYouLoading = createSelector(
  [selectHotelThankYouState],
  (hotelThankYou) => hotelThankYou.isLoading,
);

export const selectHotelThankYouError = createSelector(
  [selectHotelThankYouState],
  (hotelThankYou) => hotelThankYou.error,
);

export const selectHotelThankYouData = createSelector(
  [selectHotelThankYouState],
  (hotelThankYou) => hotelThankYou.data,
);
